import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1469.70084,963 C1595.52646,963 1711.92542,1040.38029 1759.60527,1155.357 C1807.42174,1270.60714 1777.63891,1397.88814 1680.09331,1495.50214 C1647.63276,1527.98546 1611.16568,1562.91196 1574.20934,1597.52524 L1569.16713,1602.24303 C1553.19265,1617.17491 1537.15674,1632.02503 1521.34263,1646.57143 L1521.34263,1646.57143 L1777.09243,1646.57143 L1777.09243,1920 L1230.61849,1920 C1155.06846,1920 1094,1858.88871 1094,1783.28571 L1094,1783.28571 L1094,1723.54157 C1094,1683.89443 1111.21393,1646.298 1140.99676,1620.32229 C1143.04604,1618.40829 1355.35116,1433.844 1486.91477,1302.18814 C1496.88792,1292.208 1512.73566,1273.47814 1507.1343,1259.94343 C1502.48928,1248.59614 1486.91477,1236.42857 1469.70084,1236.42857 C1419.69847,1236.42857 1360.13281,1292.34471 1339.3668,1319.41414 L1339.3668,1319.41414 L1121.3237,1154.53671 C1136.07849,1134.84986 1270.51108,963 1469.70084,963 Z M1094,142 L1094,415.454545 L683.75,415.454545 L683.75,1646 L410.25,1646 L410.25,415.454545 L0,415.454545 L0,142 L1094,142 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextSubscriptSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTextSubscriptSolid, _Component);

  var _super = _createSuper(IconTextSubscriptSolid);

  function IconTextSubscriptSolid() {
    _classCallCheck(this, IconTextSubscriptSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextSubscriptSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextSubscript",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextSubscriptSolid.displayName = "IconTextSubscriptSolid";
  return IconTextSubscriptSolid;
}(Component);

IconTextSubscriptSolid.glyphName = 'text-subscript';
IconTextSubscriptSolid.variant = 'Solid';
IconTextSubscriptSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextSubscriptSolid;
export { IconTextSubscriptSolid };